const AdminViewType = {
    SET_ADMIN_VIEW:'SET_ADMIN_VIEW',
    SET_ADMIN_LOGIN_USER_EMAIL:'SET_ADMIN_LOGIN_USER_EMAIL',
    SET_ADMIN_LOGIN_USER_ROID:'SET_ADMIN_LOGIN_USER_ROID'
}
export default AdminViewType;